module.exports = __webpack_public_path__ + "static/media/fresh-factory-ad4.f81b3377.png";